import { api } from "@/api";
import { ApiResponseType, PostPlannerSignUpRequst, PostPlannerSignUpResponse } from "@/api/type";

export const postPlannerSignUp = async(data: PostPlannerSignUpRequst
) => {
    try {
        const res = await api.post<ApiResponseType<PostPlannerSignUpResponse>>(`/api/web/visitors/planners`, data)
        return res.data;
    } catch (err) {
        console.error("postPlannerSignUp API error:", err)
        throw err;
    }
}